import { render, staticRenderFns } from "./AvatarNavigation.vue?vue&type=template&id=2b6dfa0d"
import script from "./AvatarNavigation.vue?vue&type=script&lang=js"
export * from "./AvatarNavigation.vue?vue&type=script&lang=js"
import style0 from "./AvatarNavigation.vue?vue&type=style&index=0&id=2b6dfa0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports